"use strict";const e=require("./index-df4084de.js"),a=require("./index-8b6fbbdb.js");function n(r,t){a.requiredArgs(2,arguments);var i=e.toDate(r),o=e.toDate(t);return i.getTime()<o.getTime()}exports.isBefore=n;
